<template>
  <div>
    <b-row class="mb-4">
      <b-col cols="12" offset-sm="1" sm="10">
        <h3>
          {{ $t('settings.project.projectType.themeSetting.title') }}
          -
          {{ $t('settings.project.projectType.themeSetting.direct_top_tef.name') }}
        </h3>
        <hr>
      </b-col>
    </b-row>
    <component
      v-for="(themeConfigItem, index) in themeFieldConfig"
      :key="index"
      :is="themeConfigItem.fieldType"
      :handle="themeConfigItem.handle"
      :label="themeConfigItem.title"
      :desc="themeConfigItem.desc"
      :value-from-db="themeValues[themeConfigItem.handle]"
      @update-field="updateSettingValue($event, themeConfigItem.handle)"
    />
  </div>
</template>

<script>
import ImageUploadRow from '@/components/helper/ImageUploadRow.vue';
import CheckboxRow from '@/components/helper/CheckboxRow.vue';
import InputRow from '@/components/helper/InputRow.vue';

export default {
  name: 'ThemeSettingsDirectTopTef',
  components: {
    CheckboxRow,
    ImageUploadRow,
    InputRow,
  },
  props: {
    settingValues: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      themeFieldConfig: [
        {
          handle: 'logoimage',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.logoimage.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.logoimage.desc'),
          fieldType: 'ImageUploadRow',
        },
        {
          handle: 'show_logo',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.show_logo.title'),
          desc: null,
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'title',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.title.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.title.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'article',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.article.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.article.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'scrollMenu',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.scrollMenu.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.scrollMenu.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'search',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.search.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.search.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'shadow',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.shadow.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.shadow.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'pagination',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.pagination.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.pagination.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'show_borders',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.show_borders.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.show_borders.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'navigation',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.navigation.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.navigation.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'navigation_hide',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.navigation_hide.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.navigation_hide.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'navigation_position',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.navigation_position.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.navigation_position.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'sharing',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.sharing.title'),
          desc: null,
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'sharing_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.sharing_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.sharing_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'cookies',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.cookies.title'),
          desc: null,
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'cookies_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.cookies_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.cookies_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'facebook',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.facebook.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.facebook.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'facebook_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.facebook_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.facebook_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'twitter',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.twitter.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.twitter.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'twitter_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.twitter_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.twitter_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'instagram',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.instagram.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.instagram.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'instagram_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.instagram_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.instagram_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'linkedin',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.linkedin.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.linkedin.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'linkedin_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.linkedin_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.linkedin_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'xing',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.xing.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.xing.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'xing_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.xing_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.xing_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'youtube',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.youtube.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.youtube.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'youtube_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.youtube_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.youtube_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'website',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.website.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'website_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.website_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.website_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'print',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.print.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'print_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.print_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.print_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'overview',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.overview.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'overview_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.overview_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.overview_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'imprint',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.imprint.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'imprint_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.imprint_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.imprint_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'dataprivacy',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.dataprivacy.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'dataprivacy_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.dataprivacy_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.dataprivacy_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom1',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom1.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'custom1_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom1_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom1_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom1_icon',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom1_icon.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom1_icon.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom2',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom2.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'custom2_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom2_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom2_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom2_icon',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom2_icon.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_tef.custom2_icon.desc'),
          fieldType: 'InputRow',
        },
      ],
      themeValues: {
        logoimage: {
          url: null,
          width: null,
          height: null,
          focalpoint: {
            x: 50,
            y: 50,
          },
        },
        title: null,
        article: false,
        show_logo: true,
        scrollMenu: false,
        search: false,
        navigation: true,
        navigation_hide: false,
        navigation_position: false,
        show_borders: false,
        shadow: false,
        pagination: false,
        sharing: true,
        sharing_tooltip: null,
        cookies: true,
        cookies_tooltip: null,
        facebook: null,
        facebook_tooltip: null,
        twitter: null,
        twitter_tooltip: null,
        instagram: null,
        instagram_tooltip: null,
        linkedin: null,
        linkedin_tooltip: null,
        xing: null,
        xing_tooltip: null,
        youtube: null,
        youtube_tooltip: null,
        website: null,
        website_tooltip: null,
        print: null,
        print_tooltip: null,
        overview: null,
        overview_tooltip: null,
        imprint: null,
        imprint_tooltip: null,
        dataprivacy: null,
        dataprivacy_tooltip: null,
        custom1: null,
        custom1_tooltip: null,
        custom1_icon: 'fa-heart',
        custom2: null,
        custom2_tooltip: null,
        custom2_icon: 'fa-heart',
      },
    };
  },
  created() {
    // add the values to the data
    if (this.settingValues) {
      // eslint-disable-next-line array-callback-return
      Object.entries(this.settingValues).map((itemValue) => {
        const key = itemValue[0];
        const value = itemValue[1];
        if (this.themeValues.hasOwnProperty(key)) {
          this.themeValues[key] = value;
        }
      });
      if (this.themeValues.logoimage.url) {
        if (!this.$checkForCloudImage(this.themeValues.logoimage.url)) {
          this.themeValues.logoimage.url = this.$makeCloudImage(
            this.themeValues.logoimage.url,
            { width: 450, height: 300 },
            this.themeValues.logoimage,
          );
        }
      }
    }
    this.$emit('update-theme-settings', this.themeValues);
  },
  methods: {
    updateSettingValue(value, handle) {
      if (this.themeValues.hasOwnProperty(handle)) {
        this.themeValues[handle] = value;
        this.$emit('update-theme-settings', this.themeValues);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
